import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAssist = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 12 7.125",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "vector",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7.57586 7.01836C9.48448 7.49423 11.4175 6.33276 11.8934 4.42414C12.3692 2.51552 11.2078 0.58251 9.29914 0.106637C7.39052 -0.369235 5.45751 0.792236 4.98164 2.70086C4.50577 4.60948 5.66724 6.54249 7.57586 7.01836ZM10.2007 3.05153C10.2548 3.05564 10.304 3.02013 10.3171 2.96747L10.6335 1.69862C10.6445 1.65473 10.6277 1.60859 10.5912 1.58188L9.44976 0.746471C9.41366 0.720055 9.36526 0.717812 9.32688 0.740776L8.10482 1.47194C8.059 1.49936 8.0391 1.55544 8.0574 1.6056L8.51427 2.85787C8.52924 2.89891 8.56684 2.92739 8.6104 2.9307L10.2007 3.05153ZM6.77649 1.47128C6.78701 1.4999 6.78533 1.53159 6.77183 1.55894L6.1245 2.87033C6.10763 2.9045 6.07445 2.92767 6.03656 2.93173L5.41967 2.99786C5.33896 3.00651 5.27644 2.92865 5.30232 2.85171L5.57426 2.04322C5.62186 1.90169 5.7043 1.7744 5.81399 1.67307L6.46539 1.07127C6.52368 1.01741 6.618 1.04013 6.64539 1.11462L6.77649 1.47128ZM6.16113 4.15115C6.16288 4.08877 6.21557 4.04002 6.2779 4.04311L7.63104 4.11014C7.66657 4.1119 7.69912 4.13054 7.71862 4.1603L8.5006 5.35354C8.53514 5.40624 8.51907 5.47709 8.46518 5.50974L7.44328 6.12881C7.40529 6.15183 7.35724 6.15005 7.32106 6.12428L6.17795 5.31039C6.14772 5.28886 6.13021 5.25369 6.13125 5.2166L6.16113 4.15115ZM9.96436 6.24048C9.99945 6.30193 10.0822 6.31546 10.1351 6.26837L10.9018 5.58501C11.0194 5.48021 11.1071 5.34611 11.1559 5.19638L11.4633 4.25398C11.4893 4.17422 11.4211 4.09545 11.3384 4.1098L10.6591 4.22777C10.6326 4.23237 10.6086 4.24642 10.5917 4.2673L9.61014 5.47699C9.5812 5.51265 9.57714 5.56243 9.59992 5.60231L9.96436 6.24048Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M4.6875 0.5625C4.6875 0.87316 4.43566 1.125 4.125 1.125H0.5625C0.25184 1.125 0 0.87316 0 0.5625C0 0.25184 0.25184 7.46933e-09 0.5625 7.46933e-09H4.125C4.43566 7.46933e-09 4.6875 0.25184 4.6875 0.5625Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M2.8125 6.5625C2.8125 6.87316 2.56066 7.125 2.25 7.125H0.5625C0.25184 7.125 0 6.87316 0 6.5625C0 6.25184 0.25184 6 0.5625 6H2.25C2.56066 6 2.8125 6.25184 2.8125 6.5625Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M3.75 3.5625C3.75 3.87316 3.49816 4.125 3.1875 4.125H0.5625C0.25184 4.125 0 3.87316 0 3.5625C0 3.25184 0.25184 3 0.5625 3H3.1875C3.49816 3 3.75 3.25184 3.75 3.5625Z",
				fill: "currentColor"
			})
		]
	})
});
export default SvgAssist;
